import { useParams } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import { Section } from 'foundations-components/transitional/components/Section';

// @ts-expect-error Untyped import
import DescriptiveReportsCardsGrid from '../../components/analyticsSuites/DescriptiveReportsCardsGrid';
import RecentlyViewedTemplatesSection from '../../components/analyticsSuites/RecentlyViewedTemplatesSection';
import AnalyticsSuitesSideWidget from '../../components/common/AnalyticsSuitesSideWidget';
import FeedbackLink from '../../components/analyticsSuites/FeedbackLink';
import { SUITE_LEARNING_RESOURCES } from '../../config/learningResources';
import { View } from 'foundations-components/components/View';
import EnableReportButton from '../../components/common/EnableReportButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AnalyticsSubSuite = ({
  reports,
  feedbackClient,
  showSampleZeroState
}) => {
  const {
    categoryId,
    collectionId
  } = useParams();
  const learningResources = SUITE_LEARNING_RESOURCES[categoryId];
  const hasSideWidget = learningResources && learningResources.length > 0;
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "ANALYTICS_SUITE_CATEGORY_HOME_CONTAINER",
    children: /*#__PURE__*/_jsxs(View, {
      marginBlockStart: "300",
      paddingBlockEnd: "500",
      as: "div",
      children: [/*#__PURE__*/_jsx(View, {
        position: "relative",
        children: showSampleZeroState && /*#__PURE__*/_jsx(EnableReportButton, {
          categoryId: categoryId,
          location: "ANALYTICS_SUB_SUITE"
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "h3",
        marginBlockEnd: "800",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `reports.sidebar.collections.${categoryId}`
        })
      }), /*#__PURE__*/_jsxs(TFlex, {
        align: "start",
        justify: "start",
        gap: 24,
        direction: "row",
        marginBlockStart: "400",
        children: [/*#__PURE__*/_jsxs(Box, {
          grow: 1,
          children: [/*#__PURE__*/_jsx(RecentlyViewedTemplatesSection, {
            suiteId: categoryId,
            collectionId: collectionId
          }), /*#__PURE__*/_jsx(DescriptiveReportsCardsGrid, {
            reports: reports
          })]
        }), hasSideWidget && /*#__PURE__*/_jsx(AnalyticsSuitesSideWidget, {
          feedbackClient: feedbackClient,
          suiteId: categoryId
        })]
      }), !hasSideWidget && /*#__PURE__*/_jsx(Section, {
        use: "island",
        children: /*#__PURE__*/_jsx(FeedbackLink, {
          feedbackClient: feedbackClient
        })
      })]
    })
  });
};
export default AnalyticsSubSuite;